const $blockForms = $('.form-block form');
const $ctaForms = $('.cta-cards form');

if($blockForms.length > 0) {
  setConsentLink($blockForms);
}

if($ctaForms.length > 0) {
  setConsentLink($ctaForms);
}

if($blockForms.length > 0 || $ctaForms.length > 0) {
  $blockForms.add($ctaForms).each(function() {
    const form = this;
    fillField('gclid', getUrlParam('gclid') || getCookie('gclid'), form);
    fillField('fbclid', getUrlParam('fbclid') || getCookie('fbclid'), form);
    fillField('utmsource', getUrlParam('utm_source') || getCookie('utm_source'), form);
    fillField('utmmedium', getUrlParam('utm_medium') || getCookie('utm_medium'), form);
    fillField('utmcampaign', getUrlParam('utm_campaign') || getCookie('utm_campaign'), form);
    fillField('utmcontent', getUrlParam('utm_content') || getCookie('utm_content'), form);
    fillField('utmterm', getUrlParam('utm_term') || getCookie('utm_term'), form);
    fillField('msclkid', getUrlParam('msclkid') || getCookie('msclkid'), form);
    fillField('lifatid', getUrlParam('li_fat_id') || getCookie('li_fat_id'), form);
    fillField('landingpage', getUrlParam('landing_page') || getCookie('landing_page'), form);
    fillField('referrer', getUrlParam('referrer') || getCookie('referrer'), form);
  });
}

function setConsentLink($forms) {
  $forms.each(function() {
    if($(this).find('input[data-name="privacy_policy"]').length > 0 && $(this).find('input[data-name="privacy_policy"] + span label').length > 0) {
      let $text = $(this).find('input[data-name="privacy_policy"] + span label').text();
      $text = $text.replace('Integritetspolicy', '<a href="https://upheads.se/upheads-integritets-och-persondatapolicy" target="_blank">Integritetspolicy</a> ');
      $(this).find('input[data-name="privacy_policy"] + span label').html($text);
    }
  });
}

function getUrlParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return safeDecode(urlParams.get(name) || '');
}

function safeDecode(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
}

function fillField(fieldName, value, scope = document) {
  const fields = scope.querySelectorAll(
    `input[name="${fieldName}"], input[data-name="${fieldName}"], input[id="${fieldName}"]`
  );
  if (fields.length === 0 || !value) return; // exit if field doesn't exist or no value
  fields.forEach(el => el.value = value);
}

function getCookie(name) {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return safeDecode(cookie.substring(name.length + 1));
        }
    }
    return null;
}